// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"index_breadcrumbs_2_TH4","current":"index_current_3MOVf","arrow":"index_arrow_23AcX"};